module.exports = __webpack_public_path__ + "static/media/avatar.ec1bf580.svg";